<template>
  <v-container fluid grid-list-md>
    <configurations-list></configurations-list>
  </v-container>
</template>
<script>
import ConfigurationsList from '../components/Configurations/List.vue';

export default {
  components: {
    ConfigurationsList,
  },
};
</script>
